<template>
    <div>
        <east-operate>
            <template #left>
                <el-button size="mini" type="danger" @click="handleDelete" icon="el-icon-delete"
                    >删除</el-button
                >
            </template>
            <template #right>
                <el-date-picker
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    size="mini"
                >
                </el-date-picker>
                <el-input
                    placeholder="请输入关键字"
                    style="width:200px"
                    size="mini"
                    v-model="search.keyword"
                    clearable
                >
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        size="mini"
                        title="搜索日志"
                        @click="fetchData"
                        slot="append"
                    >
                    </el-button>
                    <el-button
                        type="primary"
                        icon="el-icon-download"
                        size="mini"
                        title="下载日志"
                        @click="downData"
                        slot="append"
                    >
                    </el-button>
                </el-input>
            </template>
        </east-operate>
        <el-table
            ref="logsTable"
            :data="tableData.list"
            tooltip-effect="dark"
            :empty-text="emptyText"
            @selection-change="handleSelectionChange"
            :height="tableHeight"
            v-loading="loading"
        >
            <el-table-column
                type="selection"
                width="50"
                align="center"
                fixed="left"
            ></el-table-column>
            <el-table-column prop="operation" label="操作内容" width="200"></el-table-column>
            <el-table-column prop="url" label="请求接口"></el-table-column>
            <el-table-column prop="method" label="请求方式" width="100"></el-table-column>
            <el-table-column
                prop="addTime"
                label="操作时间"
                width="180"
                :formatter="formatter"
            ></el-table-column>
            <el-table-column prop="account" label="操作者" width="120"></el-table-column>
            <el-table-column prop="ip" label="操作IP" width="160"></el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleView(scope.$index, scope.row)"
                        >明细</el-button
                    >
                    <el-button
                        size="mini"
                        type="danger"
                        @click="
                            handleSelectionChange([scope.row])
                            handleDelete()
                        "
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search.page"
            :page-sizes="[20, 30, 50, 80, 100]"
            :page-size="search.size"
            layout="total, sizes, prev, pager, next"
            :total="tableData.total"
        >
        </el-pagination>
        <!-- 详细信息 开始 -->
        <el-drawer
            title="日志明细"
            custom-class="view-table"
            :visible.sync="viewShow"
            direction="rtl"
            size="400"
            append-to-body
        >
            <table>
                <tr>
                    <td><i class="el-icon-document"></i> 操作内容：</td>
                    <td>{{ viewData.operation }}</td>
                </tr>
                <tr>
                    <td><i class="el-icon-user"></i> 操作用户：</td>
                    <td>{{ viewData.account }} [{{ viewData.addTime }}]</td>
                </tr>
                <tr>
                    <td><i class="el-icon-link"></i> 操作IP：</td>
                    <td>{{ viewData.ip }}</td>
                </tr>
                <tr>
                    <td><i class="el-icon-arrow-right"></i> 请求接口：</td>
                    <td>{{ viewData.url }}</td>
                </tr>
                <tr>
                    <td><i class="el-icon-arrow-right"></i> 请求来源：</td>
                    <td>{{ viewData.referrer }}</td>
                </tr>
                <tr>
                    <td><i class="el-icon-arrow-right"></i> 请求方式：</td>
                    <td>{{ viewData.method }}</td>
                </tr>
                <tr>
                    <td><i class="el-icon-arrow-right"></i> 请求参数</td>
                    <td>
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 3 }">
                            {{ viewData.data }}
                        </el-input>
                    </td>
                </tr>
                <tr>
                    <td ve><i class="el-icon-arrow-right"></i> 终端信息：</td>
                    <td>
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 3 }">
                            {{ viewData.agent }}
                        </el-input>
                    </td>
                </tr>
            </table>
        </el-drawer>
        <!-- 详细信息 结束 -->
    </div>
</template>
<script>
// import { mapState } from 'vuex'
import EastOperate from '../../../../components/east-operate'
import { getLogs, deleteLogs, exportLogs } from '../../../../api/main/api-logs'
import { formatDate } from '../../../../libs/date'
import { download } from '../../../../libs/utils'
export default {
    data() {
        return {
            search: {
                keyword: '',
                stime: '',
                etime: '',
                size: 20,
                page: 1
            },
            time: ['', ''],
            tableHeight: window.innerHeight - 185,
            tableData: {},
            emptyText: ' ',
            multipleSelection: [],
            viewShow: false,
            viewData: {},
            loading: true
        }
    },
    computed: {
        // ...mapState(['user'])
    },
    components: {
        'east-operate': EastOperate
    },
    created() {
        // 组件创建完后获取数据，
        // 此时 data 已经被 observed 了
        this.fetchData()
    },
    mounted() {
        window.addEventListener('resize', () => this.measure(), false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.measure(), false)
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        $route: 'fetchData'
    },
    methods: {
        measure() {
            this.tableHeight = window.innerHeight - 185
        },
        fetchData() {
            if (this.time === null) {
                this.time = ['', '']
            }
            this.search.stime = this.time[0] || ''
            this.search.etime = this.time[1] || ''
            getLogs(this.search).then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.tableData = res.data
                } else {
                    this.emptyText = res.msg
                }
            })
        },
        downData() {
            if (this.time === null) {
                this.time = ['', '']
            }
            exportLogs({
                keyword: this.search.keyword,
                stime: this.time[0] || '',
                etime: this.time[1] || ''
            }).then(res => {
                if (download(res, `log-${formatDate(new Date(), 'yyyyMMddhhmmss')}.xlsx`)) {
                    this.$notify.success({
                        title: '成功',
                        message: '日志下载成功',
                        duration: 1500
                    })
                } else {
                    this.$notify.warning({
                        title: '提示',
                        message: '无可下载数据',
                        duration: 1500
                    })
                }
            })
        },
        formatter(row, column) {
            return formatDate(new Date(row.addTime), 'yyyy/MM/dd hh:mm')
        },
        handleSizeChange(val) {
            this.search.size = val
            this.search.page = 1
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.search.page = val
            this.fetchData()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val.map(it => {
                return it.id
            })
        },
        handleDelete() {
            if (this.multipleSelection.length === 0) {
                this.$notify.warning({
                    title: '提示',
                    message: '请选择要删除的日志',
                    duration: 1500
                })
            } else {
                this.$confirm('删除不可恢复,确认?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                })
                    .then(() => {
                        deleteLogs(this.multipleSelection).then(res => {
                            if (res.code === 0) {
                                this.search.page = 1
                                this.fetchData()
                                this.$notify.success({
                                    title: '成功',
                                    message: '日志删除成功',
                                    duration: 1500
                                })
                            } else {
                                this.$notify.error({
                                    title: '失败',
                                    message: '日志删除失败',
                                    duration: 1500
                                })
                            }
                        })
                    })
                    .catch(() => {})
            }
        },
        handleView(index, row) {
            this.viewData = row
            this.viewShow = true
        }
    }
}
</script>
<style lang="less">
.el-pagination {
    padding: 10px 5px;
}
.el-date-editor {
    width: 220px !important;
    .el-range-separator {
        color: #555555 !important;
        position: relative;
        margin-top: -2px;
    }
}
.view-table {
    overflow: auto;
    font-size: 14px;
    .el-drawer__header {
        margin-bottom: 10px;
        padding: 15px;
    }
    table {
        margin: 0 10px;
        font-size: 13px;
        tr {
            line-height: 25px;
            td:first-child {
                padding-left: 5px;
                width: 100px;
                i {
                    font-size: 16px;
                    color: #0081fa;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/security/log/log.vue